import { Modal } from "react-bootstrap";

import dangerImg from "../../Assets/Images/danger.svg";
import CloseIcon from "../../Assets/SvgIcons/Close";
import Colors from "../../Constants/Colors";

const DontCashback = (props) => {
  const { visible, onClose } = props;
  return (
    <Modal show={visible} centered={true} className="dont-cashback-modal">
      <div className="card pb-2">
        <button
          className="bg-transparent border-0 position-absolute  mt-2 mr-2"
          style={{ marginRight: 5, left: 20, top: 20 }}
          onClick={onClose}
        >
          <CloseIcon fill={Colors.gray1} width={20} height={20} />
        </button>
        <img className="dont-cashback-modal-img" src={dangerImg} />
        <p className="text-center my-3">عدم دریافت پاداش نقدی خرید</p>
        <div className="line my-3"></div>
        <div className="line h-25 bg-white d-flex align-items-center justify-content-center">
          <span className="text-center text-muted">
            به علت استفاده از این کیف پول اعتباری، به شما در این خرید، پاداش
            نقدی تعلق نمی گیرد.
          </span>
        </div>
        <div className="line my-3"></div>
        <button
          className="btn-success w-50 m-auto py-2 text-white rounded text-center border-0"
          style={{ background: Colors.green }}
          onClick={onClose}
        >
          تایید
        </button>
      </div>
    </Modal>
  );
};
export default DontCashback;
